import { render, staticRenderFns } from "./FrrScrollTop.vue?vue&type=template&id=6c48fd0c&scoped=true&"
import script from "./FrrScrollTop.vue?vue&type=script&lang=js&"
export * from "./FrrScrollTop.vue?vue&type=script&lang=js&"
import style0 from "./FrrScrollTop.vue?vue&type=style&index=0&id=6c48fd0c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48fd0c",
  null
  
)

export default component.exports